import Link from "next/link";

type Content = {
  title: string;
  content: string | string[];
  subSections?: Content[];
};

export const ContentLayout = ({ content }: { content: { sections: Content[] } }) => (
  <div className="container mx-auto space-y-12 px-4 pb-16 pt-8 md:px-16 lg:px-64">
    {content.sections.map((section, index) => (
      <ContentSection key={`${section.title}-${index}`} section={section} />
    ))}
  </div>
);

const ContentSection = ({ section }: { section: Content }) => (
  <section className="mb-6 space-y-2">
    <h3 className="mb-2 text-xl font-semibold">{section.title}</h3>
    {Array.isArray(section.content) ? (
      <ul className="list-disc space-y-2 pl-5">
        {section.content.map((item, index) => (
          <li key={`${section.title}-body-${index}`}>{parseContent(item)}</li>
        ))}
      </ul>
    ) : (
      <p>{parseContent(section.content)}</p>
    )}

    {section.subSections &&
      section.subSections.map((subSection, index) => (
        <ContentSection key={index} section={subSection} />
      ))}
  </section>
);

const parseContent = (content: string) => {
  const linkRegex = /<Link className="([^"]+)" href="([^"]+)">([^<]+)<\/Link>/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = linkRegex.exec(content)) !== null) {
    const [fullMatch, className, href, text] = match;
    const index = match.index;

    if (index > lastIndex) {
      parts.push(content.substring(lastIndex, index));
    }

    parts.push(
      <Link key={index} className={className} href={href} prefetch={false}>
        {text}
      </Link>,
    );

    lastIndex = index + fullMatch.length;
  }

  if (lastIndex < content.length) {
    parts.push(content.substring(lastIndex));
  }

  return parts;
};
